import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 42,
    seconds: 10
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="flex items-center justify-center space-x-2 text-2xl md:text-4xl font-bold text-[#faf7f0] tabular-nums" data-id="element-1">
      <div className="flex flex-col items-center" data-id="element-2">
        <div className="bg-[#23402f] border-2 border-[#c39a3f] rounded-lg px-3 py-2 min-w-[60px] md:min-w-[80px] text-center shadow-[0_6px_18px_rgba(35,64,47,0.18)]" data-id="element-3">
          {String(timeLeft.hours).padStart(2, '0')}
        </div>
        <span className="text-xs text-[#6b7566] mt-1 uppercase tracking-wider" data-id="element-4">
          Hours
        </span>
      </div>
      <span className="text-[#c39a3f] pb-5" data-id="element-5">:</span>
      <div className="flex flex-col items-center" data-id="element-6">
        <div className="bg-[#23402f] border-2 border-[#c39a3f] rounded-lg px-3 py-2 min-w-[60px] md:min-w-[80px] text-center shadow-[0_6px_18px_rgba(35,64,47,0.18)]" data-id="element-7">
          {String(timeLeft.minutes).padStart(2, '0')}
        </div>
        <span className="text-xs text-[#6b7566] mt-1 uppercase tracking-wider" data-id="element-8">
          Minutes
        </span>
      </div>
      <span className="text-[#c39a3f] pb-5" data-id="element-9">:</span>
      <div className="flex flex-col items-center" data-id="element-10">
        <div className="bg-[#23402f] border-2 border-[#c39a3f] rounded-lg px-3 py-2 min-w-[60px] md:min-w-[80px] text-center shadow-[0_6px_18px_rgba(35,64,47,0.18)]" data-id="element-11">
          {String(timeLeft.seconds).padStart(2, '0')}
        </div>
        <span className="text-xs text-[#6b7566] mt-1 uppercase tracking-wider" data-id="element-12">
          Seconds
        </span>
      </div>
    </div>;
}